import React from "react";

export const ErrorPage = () => {
  return <div>Error 404! Page not found!!</div>;
};
